const visitNodes = (visitorFn) => ({ nodes }) => {
  const nodesToTasks = (nodes2, parents) => nodes2.map((node, i, nodes3) => [node, { parents, previousSibling: nodes3[i - 1] }]);
  let tasks = nodesToTasks(nodes ?? [], []);
  while (tasks.length) {
    const [node, context] = tasks.shift();
    visitorFn(node, context);
    const parents = [node, ...context.parents];
    tasks = [...nodesToTasks(node.nodes || [], parents), ...tasks];
  }
};
const getFilteredNodes = (filterFn) => (container) => {
  const result = [];
  visitNodes((node, context) => {
    if (filterFn(node, context)) {
      result.push(node);
    }
  })(container);
  return result;
};
export {
  getFilteredNodes
};
//# sourceMappingURL=index.js.map
